import type { ITimeoutService } from 'angular';
import type { StylesConfig, WorkspaceConfig } from './WorkspaceConfig';
import type { WorkspaceLoader } from './WorkspaceLoader';
import type { AuthenticationService } from '../Auth/mx-authentication-service';
import type { NotificationService } from '../App/services/mx-notification-service';
import type { I18n } from '../i18n/mx-internationalization';
import { mx } from '../App/globals';

export class WorkspaceLoaderService {
	public static readonly $inject = [
		'$ocLazyLoad',
		'mx.shell.AuthService',
		'mx.shell.NotificationService',
		'mx.internationalization',
		'mx.sb.WorkSpaceLoader.Loader',
		'mx.sb.WorkSpaceLoader.Config',
		'$timeout',
	];

	constructor(
		private readonly $ocLazyLoad: oc.ILazyLoad,
		private readonly authService: AuthenticationService,
		private readonly notificationService: NotificationService,
		private readonly i18n: I18n,
		private readonly loader: WorkspaceLoader,
		private readonly config: WorkspaceConfig,
		private readonly $timeout: ITimeoutService
	) {
		mx.workspacesConfig = this.config;
	}

	public async loadWorkspaces() {
		const token = await this.authService.getToken();

		try {
			await this.loader.loadCustomWorkspaces(token);

			this.loader.modules.forEach((moduleName) => {
				// This `$timeout` allows to load modules independently, so Errors in one don't effect another modules
				this.$timeout(async () => {
					try {
						await this.$ocLazyLoad.inject(
							moduleName,
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							{},
							true
						);
					} catch (e) {
						console.error(`Workspace Module / Extension "${moduleName}": `, e);
					}
				});
			});
		} catch (e) {
			const msg = typeof e === 'string' ? e : e instanceof Error ? e.message : '';
			this.notificationService.error(msg, this.i18n.get('shell.mx-shell-error-message.error-label'));
			console.error(e);
		}
	}

	getCustomStyles() {
		return this.config.customStyles;
	}

	registerStyles(styles: StylesConfig[]) {
		this.config.registerStyles(styles);
	}
}
